<template>
  <div v-if="profileLoading" class="profile-container">
    <PvCard class="text-center" style="width: 350px">
      <template #content>
        <i :class="ICONS.User" class="icon-loading" ></i>
        <div><strong>Loading profile...</strong></div>
      </template>
    </PvCard>
  </div>
  <PageHeader v-if="!profileLoading" />
  <HceHome v-if="!profileLoading && store.authenticated && store.user.isHceOnlyUser" />
  <GeneralHome v-else-if="!profileLoading && store.authenticated && !store.user.isAdminUser" />
  <ProgramDashboard v-else-if="!profileLoading && store.authenticated && store.user.isAdminUser" /> 
</template>

<script setup>
// ===============================
// IMPORTS
// ===============================
// Vue Core
import { computed } from 'vue';

// Components
import GeneralHome from '@/components/home/GeneralHome.vue';
import PageHeader from '../components/common/PageHeader.vue';
import HceHome from '@/components/home/HceHome.vue';
import ProgramDashboard from '@/modules/program/components/ProgramDashboard.vue';

// Composables

// Stores
import { useAuthStore } from '@/stores/authStore';

// Constants and Utils
import { ICONS } from '@/utils/constants';

// ===============================
// PROPS & EMITS
// ===============================

// ===============================
// COMPOSABLES & STORES
// ===============================
const store = useAuthStore();

// ===============================
// REACTIVE STATE
// ===============================

// ===============================
// CONSTANTS
// ===============================

// ===============================
// COMPUTED PROPERTIES
// ===============================
const profileLoading = computed(() => store.loadingProfile);

// ===============================
// METHODS
// ===============================

// ===============================
// WATCHERS
// ===============================

// ===============================
// LIFECYCLE HOOKS
// ===============================

// ===============================
// EXPOSE
// ===============================

</script>

<style scoped>

.icon-loading {
  font-size: 2rem;
  margin-bottom: 1rem;
}

.profile-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%; /* Full viewport height */
  background-color: rgba(0, 0, 0, 0.5); /* Transparent overlay background */
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000; /* Ensure it is above other content */
}
</style>




